<template>
  <div>
    <van-loading style="position:fixed;margin:0 auto;left:50%;top:30%;transform:translate(-50%,0)" 
      color="#1989fa" size="24px" v-show="loading" vertical>
      <div style="color:#1989fa;">
        加载中...
      </div>
    </van-loading>
    <van-nav-bar
      @click-left="$router.go(-1)"
      left-arrow
      left-text="返回"  />
    <div class="order-list" v-if="orderList.length > 0">
      <!-- <div class="order-list-item" v-for="(item, index) in orderList" :class="item.noticeType==0?'xiaox':'video'" :key="index" @click="linkDetail(item)"> -->
      <div class="order-list-item" v-for="(item, index) in orderList" :class="item.noticeType==0?'xiaox':'video'" :key="index" @click="item.orderState == 1 && !item.isOrderExceed?'':linkDetail(item)">
        <div class="flex flex-b">
          <div style="font-size: 0.875rem">
            <span style="color: #666666">
              产品名称：
              <span style="color: #1a1a1a">
                {{ item.productName }} 
                <!-- <span v-show="item.type==0">
                  <span v-if="item.productName == '半年卡'">
                  / 6个月
                    <span style="margin: 0 0.45rem">￥55</span>
                  </span>
                  <span v-if="item.productName == '月卡'">
                    / 1个月
                    <span style="margin: 0 0.45rem">￥10</span>
                  </span>
                  <span v-if="item.productName == '年卡'">
                    / 12个月
                    <span style="margin: 0 0.45rem">￥100</span>
                  </span>
                </span> -->
                ￥{{item.productPrice / 100}}
              </span>
            </span>
          </div>
          <van-tag
            type="success"
            v-if="item.orderState == 1 && item.isOrderExceed"
            >已付款</van-tag
          >
          <van-tag
            color="#999999"
            v-if="item.orderState == 1 && !item.isOrderExceed"
            >已过期</van-tag
          >
          <van-tag type="danger" v-if="item.orderState == 0" color="#ff8a48"
            >待付款</van-tag
          >
          <van-tag type="danger" v-if="item.orderState == 2">已关闭</van-tag>
        </div>
        <div>
          <div style="margin-bottom: 0.6rem">
            <span style="color: #666666">订阅人数：</span>
            <span style="color: #1a1a1a">
              {{ item.packageName }}
              <!-- item.type为0代表普通订阅 -->
              <span style="margin: 0 0.45rem" v-show="item.type==0">
                {{ item.discount == 1 ? "原价" : item.discount * 10 + "折" }}
              </span>
            </span>
          </div>
          <div style="margin-bottom: 0.1rem">
            <span style="color: #666666">孩子信息：</span>
            <span style="color: #1a1a1a">
              {{ item.child.name }}
              <span style="margin: 0 0.45rem">{{ item.child.schoolName }}</span>
              <span>{{ item.child.className }}</span>
            </span>
          </div>
        </div>
        <div v-if="item.payTime&&item.type==1">
           <span style="color: #666666; font-size: 0.63rem"
            >服务已订阅</span>
            <!-- {{item.noticeType==0?'消息':'视频'}} -->
        </div>
        <div v-else-if="item.payTime">
          <!-- {{item.noticeType==0?'消息':'视频'}} -->
          <span style="color: #666666; font-size: 0.63rem">订阅到期时间：{{ getDate(item.dueDate) }}</span
          >
        </div>
        <div v-if="item.payTime">
          <span style="color: #666666; font-size: 0.63rem"
            >付款时间：{{ getDateYMD(item.payTime) }}</span
          >
        </div>
        <div class="flex flex-r price">
          <span>总价：￥{{ item.originalPrice / 100 }}</span>
          <span
            >优惠：￥{{ item.originalPrice / 100 - item.realPrice / 100==0?'0':(item.originalPrice / 100 - item.realPrice / 100).toFixed(2) }}</span>
          <span
            >{{ item.orderState == 0 ? "需" : "实" }}付款：￥{{
              item.realPrice / 100
            }}</span
          >
        </div>
        <div class="flex flex-r" v-if="item.orderState == 0">
          <!-- <van-button
            plain
            hairline
            type="default"
            size="small"
            style="padding: 0 0.5rem;"
            >取消</van-button
          > -->
          <!-- <van-button
            plain
            hairline
            type="info"
            size="small"
            @click.stop="payOrder(item.orderNumber)"
            >付款</van-button
          > -->
          <div class="btn" @click.stop="CancelPayOrder(item.orderNumber)">
            取消订单
          </div>
          <div
            class="btn"
            @click.stop="payOrder(item.orderNumber)"
            style="
              color: #e68829;
              border: 0.06rem solid #e68829;
              padding-left: 1.5rem;
              padding-right: 1.5rem;
            "
          >
            付款
          </div>
          <!-- <van-button
            plain
            hairline
            type="warning"
            size="small"
            style="padding: 0 0.5rem; margin-left: 0.5rem;"
            >绑定人员</van-button
          > -->
          <!-- <div>取消</div>
          <div>付款</div>
          <div>付款</div> -->
        </div>
        <div
          class="flex flex-r"
          v-if="item.orderState == 1 && item.isOrderExceed"
        >
          <!-- <div  v-if="item.orderState == 1 && item.isOrderExceed&&item.type==0"
            class="btn"
            @click.stop="againOrder(item)"
            style="
              color: #1a88f9;
              border: 0.06rem solid #1a88f9;
              padding-left: 1.5rem;
              padding-right: 1.5rem;
            ">
            再来一单
          </div> -->
          <div class="btn" @click.stop="linkBindService(item)">
            修改订阅人员
          </div>
        </div>
        <!-- <div
          class="flex flex-r"
          v-if="item.orderState == 1 && !item.isOrderExceed"
        >
          <div class="btn" @click.stop="againOrder(item)">续费</div>
        </div> -->
      </div>
    </div>
    <div class="order-list" v-else>
      <van-empty description="暂无数据" v-show="!loading" />
    </div>
  </div>
</template>

<script>
import wxSDK from "@/utils/wxSDK.service";
import assign from "@/mixins/assign";
import moment from "moment";
export default {
  mixins: [assign],
  data() {
    return {
      orderList: [],
      loading:true,
    };
  },
  mounted() {
    this.getMyOrder();
  },
  methods: {
    getDateYMD(value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
    getDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },

    async getMyOrder() {
      this.loading=true;
      const { code, data } = await this.$https.getMyOrder({
        pageNum: 1,
        pageSize: 500,
        mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
        //schoolId: JSON.parse(localStorage.getItem("userInfo"))
        // .patriarchSchoolId,
        // state: '',
        ///userId: JSON.parse(localStorage.getItem("userInfo")).patriarchUserId,
      });
      if (code !== 200) {
        this.loading=false;
        this.$toast("获取订单列表失败");
        return false;
      }
        this.loading=false;
      // noticeType(0消息订阅，1短视频订阅)
      this.orderList = data
        ? data.list.map((item) => {
            item.isOrderExceed = moment(item.dueDate).isAfter(moment());
            return item;
          })
        : [];
      this.orderList = this.orderList.filter((item) => {
        return item.orderState != 2;
      });
      // for (var i = 0; i < this.orderList.length; i++) {
      //       if (this.orderList[i].orderState == 2) {
      //         this.orderList.splice(i, 1);
      //       }
      //   }
      console.log(this.orderList);
    },
    //取消订单
    async CancelPayOrder(orderNumber) {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "您确定取消订单吗？",
        })
        .then(() => {
          for (var i = 0; i < this.orderList.length; i++) {
            if (this.orderList[i].orderNumber == orderNumber) {
              this.orderList.splice(i, 1);
              this.cancelOrder(orderNumber);
              break;
            }
          }
          console.log("取消订单", this.orderList);
        })
        .catch(() => {
          // on cancel
        });
      //console.log('num',orderNumber)
      //console.log('取消',this.orderList)
    },
    //取消订单
    async cancelOrder(num) {
      const { data, code } = await this.$https.cancelOrder({
        orderNumber: num,
      });
      if (code !== 200) {
        this.$toast("取消订单失败");
        return;
      }
      this.$toast("取消订单成功");
    },
    //支付订单
    async payOrder(orderNumber) {
      try {
        const { data, code, msg } = await this.$https.createPayOrder({
          outTradeNo: orderNumber,
        });
        if (code !== 200) {
          this.$toast("下单失败" + msg);
          return false;
        }
        const jsinit = await wxSDK.jsSDKConfig();
        if (jsinit == "err") {
          this.$toast("微信sdk初始化失败，请重试");
          return false;
        }
        const resultPay = await wxSDK.chooseWXPay(data);
        if (resultPay == "支付失败") {
          this.$toast("支付失败");
        } else if (resultPay == "支付取消") {
          // 跳转订单列表
          this.$toast("支付取消");
        } else {
          // 支付成功
          console.log("支付成功-----", resultPay);
          const res = await this.$https.getPayOrder({
            outTradeNo: orderNumber,
          });
          if (res.code !== 200) {
            this.$toast("查询支付结果失败");
            return;
          }
          this.$toast("支付成功");
          this.getMyOrder();
          console.log("查询支付状态", res);
          // this.$router.push('/paySuccess')
        }
      } catch (error) {}
    },
    //跳转订单详情
    linkDetail(item) {
      sessionStorage.setItem("order_detail", JSON.stringify(item));
      this.$router.push({
        path: "/orderDetail",
      });
    },
    //点击修改订阅人员
    linkBindService(item) {
      sessionStorage.setItem("order_detail", JSON.stringify(item));
      this.$router.push(
        `/bindService?orderNumber=${item.orderNumber}&userNumber=${item.userNumber}&childrenId=${item.childrenId}`
      );
    },
    //获取订单详情
    getOrderDetail(orderNumber) {
      return new Promise(async (resolve, reject) => {
        const res = this.$https.getOrderDetail({
          orderNumber,
        });
        resolve(res);
      });
    },
    //再来一单
    async againOrder(value) {
      const { data, code, msg } = await this.getOrderDetail(value.orderNumber);
      if (code !== 200) {
        this.$toast("获取详情失败");
        return;
      }
      console.log("详情", data);
      const item = data;
      sessionStorage.setItem(
        "shopping_cart",
        JSON.stringify({
          item: this.affirmData(item,value),
        })
      ); 
      this.$router.push({
        path: `/confirmOrder`,
        query: {
          orderNumber: value.orderNumber,
          parentId: value.userId,
          childId: value.childrenId,
          schoolId: value.schoolId,
        },
      });
      console.log("再来一单", data);
    },
    affirmData(item,value) {
      const originalPrice = (item.originalPrice / 100).toFixed(0);
      const realPrice = (originalPrice * item.discount).toFixed(0);
      const differencePrice = (originalPrice - realPrice).toFixed(0);
      console.log('我是商品价格');
      console.log(value.productPrice);
      return {
        productName: item.productName,
        packageName: item.packageName,
        originalPrice: originalPrice,
        discount: item.discount == 1 ? "原价" : item.discount * 10 + "折",
        realPrice,
        differencePrice,
        peopleNum: item.userNumber,
        productId: item.productId,
        packageId: item.packageId,
        childRadio: item.childrenId,
        productPrice:(value.productPrice / 100)
      };
    },
  },
};
</script>

<style lang="scss" scoped>

.order-list {
  padding: 0.5rem;
  .order-list-item {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 0.75rem;
   
    padding: 0.8rem;
    font-size: 0.85rem;
    color: #454f63;
    margin-bottom: 0.5rem;
    > div {
      margin-bottom: 0.6rem;
      &.price {
        font-size: 0.8rem;
        color: #666666;
        margin-left: 0.3rem;
        span {
          margin-left: 1rem;
        }
      }
    }
  }
  .order-list-item.xiaox{
     border-left: #1A88F9 3px solid;
  }
  .order-list-item.video{
    border-left:#5C37DA 3px solid;
  }
}
.btn {
  border: 0.06rem solid #1a1a1a;

  border-radius: 2rem;
  font-size: 0.75rem;
  color: #1a1a1a;
  padding: 0.2rem 0.8rem;
  margin-left: 0.38rem;
  &.fk {
    background: #ff8a48;
    color: #fff;
    border: 0.06rem solid #ff8a48;
  }
}
</style>
